export function formatDomainName(name: string): string | null {
    let formattedName = name.toLowerCase();

    // Normalise and remove diacritical marks eg. café and crème brûlée
    formattedName = formattedName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    // Replace "+" with "plus"
    formattedName = formattedName.replace(/\+/g, 'plus');

    // Replace "&" with "and"
    formattedName = formattedName.replace(/&/g, 'and');

    // Remove special characters that not alphanumeric or hyphens
    formattedName = formattedName.replace(/[^a-z0-9-]/g, '');

    // Remove leading or trailing hyphens from the name
    formattedName = formattedName.replace(/^-+|-+$/g, '');

    // Replace multiple consecutive hyphens
    formattedName = formattedName.replace(/-+/g, '-');

    // Check maximum length
    if (formattedName.length > 63) {
        formattedName = formattedName.substring(0, 63);
    }

    return formattedName;
}
